import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import UserProfile from '../global/UserProfile';
import Footer from '../footer';
import ProjectList from './project_list';
import { fetchPermissionsByModule } from '../../actions/project_actions';

import {SITE_SAFETY_URL, FEP_LITE_URL, TASK_ORDER_URL, BMX_MY_DASHBOARD_URL, CHANGE_REQUEST_URL} from '../../actions/index'; 

const getNavItemMatching = (match) => ({ url, text}) => (
  <li className={match.url === url ? 'active': null}>
    <Link to={url}>{text}</Link>
  </li>
);


class MainPage extends React.Component {

    componentDidMount() {
        this.props.fetchPermissionsByModule(this.props.projectId);
    }

    render () {
        const { match } = this.props;
        const NavItem = getNavItemMatching(match);
        const { isDesignDir, isSustDir, isTeamLeaderAnyProject, isTeamMemberAnyProject, isStudioMember } = this.props.permissionsModule;

        return (
      <div>
        <div className="App-header">
          <div className="container">
            <div className="row">              
              <div className="col s3">
                <h2>
                  <Link to="/">
                    <span className="MT-Logo"></span>
                  </Link>
                </h2>                
              </div>                  
              <UserProfile />
            </div>
          </div>
        </div>
        <nav className="App-topnav">
          <div className="container">
            <div className="row">
              <div className="col s12">
                <ul>

                  {isDesignDir || isSustDir || isTeamLeaderAnyProject || isTeamMemberAnyProject || isStudioMember
                    ? <NavItem url='/aeProjects' text="A&E projects" />
                    : <NavItem url='/my-projects' text="My projects" />}
                    
                  {isDesignDir || isSustDir || isTeamLeaderAnyProject || isTeamMemberAnyProject || isStudioMember
                    ? <NavItem url='/aeSearch' text="A&E Search" /> : null}

                    {/* <li><a href={BMX_MY_DASHBOARD_URL} target='_self'  >My Dashboard </a></li> */}

                  {isDesignDir || isSustDir || isTeamLeaderAnyProject || isTeamMemberAnyProject || isStudioMember
                    ? null
                    : <NavItem url='/watchlist' text="Watch List" />}
                 
                  <NavItem url='/search'        text ="Search" />
                  <NavItem url='/reports'        text ="Reports" />
           


                  <li><a href={FEP_LITE_URL} target='_self'  >FEP </a></li>
                  <li><a href={TASK_ORDER_URL} target='_self'  >Task Order </a></li>
                  <li><a href={CHANGE_REQUEST_URL} target='_self'  >Change Request </a></li>
                  <li><a href={SITE_SAFETY_URL} target='_self'  >Safety Plan </a></li>

                </ul>
              </div>
            </div>
          </div>
        </nav>
        <ProjectList params={match.params} />
        <Footer />
      </div>
        );
    }
}

MainPage.propTypes = {
    match: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        permissionsModule: state.projectsStore.permissionsModule,
    }
}

export default connect(mapStateToProps, {fetchPermissionsByModule}) (MainPage);